/*
 * Filename: component-config-root-component.tsx
 * Description: component for config root container.
 */

import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { GridComponentIcon } from './grid-component-icon';
import { GridComponentCompName } from './grid-component-comp-name';
import { GridComponentFieldsToDisplay } from './grid-component-fields-todisplay';
import { GridComponentFilterByRecordType } from './grid-component-filter-by-record';
import { GridComponentOrderType } from './grid-component-order-type';
import { GridComponentAdditionalFilter } from './grid-component-additional-filter';
import { GridComponentSortType } from './grid-component-sort-type';
import { GridComponentPrefix } from './grid-component-prefix';
import { GridComponentSuffix } from './grid-component-suffix';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { GridComponentCustomTitle } from './grid-component-custom-title';
import { CQAppConstant } from '../../../../app-constants';
import { IFieldData } from '../../component-level-fields/component-field';
import { Utility } from '../../../../common/utility';
import { GridComponentDefaultFieldValue } from './grid-component-default-field-value';


interface IProps {
  handleChange: Function;
  componentFields: any[];
  selectedTemplateName: string;
  setCustomComponent: Function;
  errors: any;
}

class GridComponentConfigRootContainer extends Component<IProps, any> {
  private templateConfigCtrl: GridTemplateConfigurationController;
  private cqUtility: Utility;

  constructor(props: Readonly<IProps>) {
    super(props);
    this.templateConfigCtrl = new GridTemplateConfigurationController();
    this.cqUtility = new Utility();

    this.state = {
      isFormValid: false,
      viewSourceComponentConfig: {},
    };
  }
  componentDidMount() {
    let ruleElements = 
      CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
    if (ruleElements.hasOwnProperty('gridObject')) {
      CQMasterDataStore.GridObject.updateGridField(
        'gridComponentConfigView',
        ruleElements.gridObject.gridComponentConfigView
      );
    } else {
      ruleElements = {
        gridObject: {
          gridComponentConfigView: {},
        },
      };
      CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
        this.props.selectedTemplateName,
        "ruleElements",
        ruleElements
      );
      CQMasterDataStore.GridObject.updateGridField(
        "gridComponentConfigView",
        ruleElements.gridObject.gridComponentConfigView
      );
    }
    const viewSourceComponentConfig =
      ruleElements.gridObject.gridComponentConfigView;

    if (
      viewSourceComponentConfig &&
      Object.keys(viewSourceComponentConfig).length > 0
    ) {
      this.setState({
        viewSourceComponentConfig,
        isFormValid: true,
      });
    }
  }

  /**
   * @memberof GridComponentConfigRootContainer
   */
  public updateViewSourceComponentConfig = (
    fieldName: string,
    fieldValue: any,
    compName?: any,
    suffix?: string
  ) => {
    const viewSourceConfig =
      CQMasterDataStore.GridObject.gridComponentConfigView;
    let ruleElements = 
      CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
    let viewSourceComponentConfig = {
      ...viewSourceConfig,
      [fieldName]: fieldValue,
    };
    if (compName) {
      viewSourceComponentConfig = {
        ...viewSourceComponentConfig,
        componentName: compName,
      };
    }
    if (suffix !== undefined && suffix !== "undefined" && suffix !== "") {
      viewSourceComponentConfig = {
        ...viewSourceComponentConfig,
        suffix: suffix.trim(),
      };
      CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
        this.props.selectedTemplateName,
        `suffixName`,
        suffix.trim()
      );
    }

    this.setState(
      {
        viewSourceComponentConfig,
      },
      async () => {
        if (ruleElements.hasOwnProperty("gridObject")) {
          let gridObject = { ...ruleElements.gridObject };
          gridObject.gridComponentConfigView = viewSourceComponentConfig;
          ruleElements.gridObject = gridObject;
        } else {
          ruleElements = {
            gridObject: {
              gridComponentConfigView: {},
            },
          };
          ruleElements.gridObject.gridComponentConfigView =
            viewSourceComponentConfig;
        }
        if (fieldName === "suffix" || fieldName === "prefix") {
          CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
            this.props.selectedTemplateName,
            `${fieldName}Name`,
            fieldValue
          );
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
          this.props.selectedTemplateName,
          "ruleElements",
          ruleElements
        );
        CQMasterDataStore.GridObject.updateGridField(
          "gridComponentConfigView",
          viewSourceComponentConfig
        );
        if (compName) {
          this.templateConfigCtrl.updateFieldValue(
            "componentName",
            compName,
            this.props.selectedTemplateName
          );
        }
      }
    );
  };

  public updateViewSource = (
    viewSourceComponentConfig: any,
    fieldToDisplayElement?: any
  ) => {
    this.setState(
      {
        viewSourceComponentConfig,
      },
      () => {
        let ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        if (ruleElements.hasOwnProperty("gridObject")) {
          let gridObject = { ...ruleElements.gridObject };
          // gridObject.gridComponentConfigView = viewSourceComponentConfig;
          if (Array.isArray(fieldToDisplayElement)) {
            fieldToDisplayElement = fieldToDisplayElement[0];
            let index = -1;
            if (viewSourceComponentConfig.fieldsVisibilityRules) {
              index = viewSourceComponentConfig.fieldsVisibilityRules.findIndex(
                (field: any) =>
                  field.label === fieldToDisplayElement.label &&
                  field.groupName === fieldToDisplayElement.groupName
              );
            }
            if (index !== -1) {
              viewSourceComponentConfig.fieldsVisibilityRules =
                viewSourceComponentConfig.fieldsVisibilityRules.filter(
                  (field: any, key: number) => key != index
                );
            }
          }
          gridObject.gridComponentConfigView = {
            ...viewSourceComponentConfig,
          };
          ruleElements.gridObject = gridObject;
        } else {
          ruleElements = {
            gridObject: {
              gridComponentConfigView: {},
            },
          };
          ruleElements.gridObject.gridComponentConfigView =
            viewSourceComponentConfig;
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
          this.props.selectedTemplateName,
          "ruleElements",
          ruleElements
        );
        CQMasterDataStore.GridObject.updateGridField(
          "gridComponentConfigView",
          viewSourceComponentConfig
        );
      }
    );
  };

  public renderViews = (field: IFieldData) => {
    switch (field.inputParamKey) {
      case CQAppConstant.ICON_NAME:
        return (
          <GridComponentIcon
            key= {field.inputParamKey}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "fieldsToDisplay":
        return (
          <GridComponentFieldsToDisplay
            key={field.inputParamKey}
            updateViewSource={this.updateViewSource}
            selectedTemplateName={this.props.selectedTemplateName}
            viewSourceComponentConfig={this.state.viewSourceComponentConfig}
            setCustomComponent={this.props.setCustomComponent}
            fieldInfo= {field}
          />
        );

      case "prefixName":
        return (
          <GridComponentPrefix
            key={field.inputParamKey}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "suffixName":
        return (
          <GridComponentSuffix
            key={field.inputParamKey}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "sortOrder":
        return (
          <GridComponentSortType
            key={field.inputParamKey}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "componentName":
        return (
          <GridComponentCompName
            key={field.inputParamKey}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "customTitle":
        return (
          <GridComponentCustomTitle
            key={field.inputParamKey}
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "andClause":
        return (
          <GridComponentAdditionalFilter
            key={field.inputParamKey}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "limitToRecordType":
        return (
          <GridComponentFilterByRecordType
            key={field.inputParamKey}
            updateViewSource={this.updateViewSource}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "orderBy":
        return (
          <GridComponentOrderType
            key={field.inputParamKey}
            updateViewSourceComponentConfig={
              this.updateViewSourceComponentConfig
            }
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo= {field}
          />
        );

      case "defaultFieldValue":
        return (
          <GridComponentDefaultFieldValue
            key={field.inputParamKey}
            selectedTemplateName={this.props.selectedTemplateName}
            fieldInfo={field}
          />
        );

      default:
        return null;
    }
  };

  render(): ReactNode {
    const templateObj = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
    if (!templateObj.parentObjectApiName) {
      return <div>Please select Parent Object</div>;
    }

    return (
      <div
        id="tab-default-1"
        className="slds-tabs_default__content slds-p-around_small full-height scroll-content"
        role="tabpanel"
        aria-labelledby="tab-default-1__item"
      >
        <div className="slds-grid slds-wrap">
          {this.props.componentFields.length > 0 &&
            this.props.componentFields.map((field: IFieldData, index: number) => {
              return (
                <div key= {field.inputParamKey} className= {this.cqUtility.getColumnClassName(field.size)}>
                  {this.renderViews(field)}
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}
export default observer(GridComponentConfigRootContainer);
